import { defineComponent as l, openBlock as t, createBlock as n, unref as r, mergeProps as p, withCtx as c, createElementVNode as m } from "vue";
import { RevIcon as u } from "@ds/components/Icon";
const s = /* @__PURE__ */ l({
  name: "IconCupcake",
  __name: "IconCupcake",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(a) {
    const o = a;
    return (i, e) => (t(), n(r(u), p(o, { "view-box": "0 0 24 24" }), {
      default: c(() => [...e[0] || (e[0] = [
        m("path", {
          "fill-rule": "evenodd",
          d: "M12.591 3.273c-.8-.1-1.297.56-1.366 1.12A3.25 3.25 0 0 1 8 7.237v.038a3.25 3.25 0 0 0-2.75 3.212v.812a1.25 1.25 0 0 0-.822 1.491l1.75 7a1.25 1.25 0 0 0 1.212.947h9.22a1.25 1.25 0 0 0 1.212-.947l1.75-7a1.25 1.25 0 0 0-.822-1.491v-.812a3.25 3.25 0 0 0-2.027-3.012 4.75 4.75 0 0 0-4.132-4.202m2.572 3.964a3.26 3.26 0 0 0-2.484-2.43 4.74 4.74 0 0 1-1.215 2.43h3.699M8.5 8.737a1.75 1.75 0 0 0-1.75 1.75v.75h10.5v-.75a1.75 1.75 0 0 0-1.75-1.75h-7m.338 4H5.96l1.625 6.5h8.83l1.624-6.5h-2.877l-.418 3.343a.75.75 0 1 1-1.488-.186l.394-3.157h-3.3l.394 3.157a.75.75 0 1 1-1.488.186l-.418-3.343",
          "clip-rule": "evenodd"
        }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  s as default
};
